import { render, staticRenderFns } from "./rdsz.vue?vue&type=template&id=4ff25750&"
import script from "./rdsz.vue?vue&type=script&lang=js&"
export * from "./rdsz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports